import { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { trackPageView } from '../../services/tracking';
import { updateSubscription } from '../../reducers/subscription';
import { completeStep } from '../../reducers/steps';
import Option from './Option';

import { Button } from '../button';
import { Row, Col } from '../grid';
import { Input } from '../input';
import { FormActions } from '../formActions';
import { PageHeader } from '../pageHeader';

import Summary from '../summary';

function BrewingMethod(props){
  const formikRef = useRef();
  const dispatch = useDispatch();

  const subscription = useSelector((state) => state.subscription);
  const brewingMethods = useSelector((state) => state.brewingMethods);

  const initialValues = { ...subscription };

  const validate = (values) => {
    const errors = {};

    if(values.ground !== 'true' && values.ground !== 'false'){
      errors.brewingMethod = 'Escolha um método para continuar';
    }

    if(!values.brewingMethod){
      errors.brewingMethod = 'Escolha um método para continuar';
    }

    console.log(errors)

    return errors;
  }

  const handleClick = (ground) => {
    formikRef.current.setFieldValue('ground', ground.toString());

    dispatch(updateSubscription({
      ground: ground.toString(),
    }));
  }

  const handleBrewingMethodChange = (e) => {
    formikRef.current.setFieldValue('brewingMethod', e.target.value);

    dispatch(updateSubscription({
      brewingMethod: parseInt(e.target.value)
    }));
  }

  const handleSubmit = (values) => {
    dispatch(completeStep(4));
    props.history.push('/entrega');
  }

  useEffect(() => {
    trackPageView();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validate={validate}
      >
        {({ values }) => (
          <Form>
            <PageHeader>
              <small>Método de preparo</small>
              <h1>Como você quer receber o seu café?</h1>
              <p>
                Em grãos ou moído?
                <br />
                Aqui fazemos do seu jeito.
              </p>
            </PageHeader>

            <Row>
              <Col>
                <Option
                  current={values.ground}
                  icon="wholeBean"
                  ground="false"
                  onClick={() => handleClick(false)}
                >
                  <div className="title">
                    Em grãos
                  </div>
                </Option>
              </Col>

              <Col>
                <Option
                  current={values.ground}
                  icon="ground"
                  ground="true"
                  onClick={() => handleClick(true)}
                >
                  <div className="title">
                    Moído
                  </div>
                </Option>
              </Col>
            </Row>

            <Input
              name="brewingMethod"
              as="select"
              label="Qual método você usa?"
              onChange={handleBrewingMethodChange}
              options={brewingMethods}
              onClick={(e) => e.stopPropagation()}
            />

            <Summary />

            <FormActions backUrl="/plano-gateway" backDescription="Sua caixinha">
              <Button
                type="submit"
                icon="angle-right"
                align="right"
                description="Endereço de entrega"
              >
                Continuar
              </Button>
            </FormActions>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default withRouter(BrewingMethod);
